// import { io } from 'socket.io-client'; // DISABLED to prevent runaway requests
import toast from "react-hot-toast";
import { safeGet, safePost, safeDelete } from '../../../config/axiosClient.js';

export const getArrivalData = () => {
    return async dispatch => {
        const { data, error } = await safeGet('/api/arrival');

        if (error) {
            // Logged by axiosClient, no need to spam console
            // App will retry on next poll interval (30s)
            return;
        }

        if (data?.success) {
            dispatch({
                type: "Set_Arrival_Data",
                data: [...data.data]
            });
        } else if (data?.message) {
            toast(data.message);
        }
    };
}

export const setArrivalData = (returnArray) => {
    return dispatch => {
        let data_array = [...returnArray];

        dispatch({
            type: "Set_Arrival_Data",
            data: data_array
        })
    }
}

export const deleteArrivalData = (id) => {
    return async dispatch => {
        const { data, error } = await safeDelete(`/api/arrival/${id}`);

        if (error) {
            console.error('Error deleting arrival data:', error.message);
            if (!error.isOffline) {
                toast.error('Failed to delete item');
            }
            return;
        }

        if (data?.success) {
            dispatch({
                type: "Set_Arrival_Data",
                data: [...data.data]
            });
        }
    };
}

export const addArrivalData = (files, newArray, UploadType, CompanyName) => {
    return async dispatch => {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('photos', file);
        });
        formData.append('airportInfo', JSON.stringify(newArray));
        formData.append('fileType', UploadType);
        formData.append('companyName', CompanyName);

        const { data, error } = await safePost('/api/upload', formData);

        if (error) {
            console.error('Upload error:', error.message);
            if (!error.isOffline) {
                const errorMessage = error.response?.data?.message || error.message || 'Upload failed';
                toast.error(`Upload failed: ${errorMessage}`);
            }
            return;
        }

        if (data?.success) {
            let arrivalArray = [];
            let DepartureArray = [];
            let data_array = [...data.data];

            for (var i = 0; i < data_array.length; i++) {
                if (data_array[i].AirportInfo.wing === "arrival") {
                    arrivalArray.push(data_array[i]);
                } else {
                    DepartureArray.push(data_array[i]);
                }
            }

            dispatch({
                type: "Set_Arrival_Data",
                data: arrivalArray
            });

            dispatch({
                type: "Set_Departure_Data",
                data: DepartureArray
            });

            toast.success(data.message || "Files uploaded successfully!");

            // Show warnings if there were any partial upload errors
            if (data.errors && data.errors.length > 0) {
                data.errors.forEach(err => {
                    toast.error(`Warning: ${err}`);
                });
            }
        } else {
            toast.error(data?.message || "Upload failed");
        }
    };
}